import React from "react";
import { Box, Pill } from "app/components/common";
import TimerIcon from "app/components/Icons/TimerIcon";
import TeamIcon from "app/components/Icons/MultiplePeopleIcon";
import normalize from "app/utils/normalize";

interface Props {
  skill?: string;
}

const CardInfos = ({ skill = "Leadership" }: Props) => {
  return (
    <Box flexDirection="row" marginTop="m" overflow="hidden">
      <Pill
        marginBottom="sm"
        marginRight="xs"
        text="10 min"
        icon={
          <TimerIcon
            width={normalize(16)}
            height={normalize(16)}
            color="white"
          />
        }
      />
      {/* <Pill
        marginBottom="sm"
        marginRight="xs"
        text="1 278"
        icon={
          <TeamIcon
            width={normalize(16)}
            height={normalize(16)}
            color="white"
          />
        }
      /> */}
      {!!skill && <Pill text={skill} marginBottom="sm" />}
    </Box>
  );
};

export default CardInfos;
